/**
 * Represents the possible file types that can be downloaded.
 */
export enum DownloadFileType {
  xlsx = 'xlsx',
  csv = 'csv',
}
